<div class="dropzone" [ngClass]="color">
  <ngx-file-drop
    dropZoneLabel="Drop files here"
    (onFileDrop)="dropped($event)"
    [accept]="filesToAccept"
    [multiple]="acceptMultiple"
    [disabled]="!acceptLimit"
  >
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <mat-icon>backup</mat-icon>
      <p>Arrastra y suelta aquí</p>
      <p>o</p>
      <button mat-stroked-button type="button" [color]="color" class="browse-btn" (click)="openFileSelector()" [disabled]="!acceptLimit">
        Sube tus archivos
      </button>
    </ng-template>
  </ngx-file-drop>
  <div class="upload-table mt-3">
    <h2>Archivos a subir: Máximo {{ acceptLimit }}</h2>
    <div class="responsive-table">
      <table class="table">
        <thead>
          <tr>
            <th [ngClass]="{ 'text-center': files.length }"> Nombre </th>
            @if (files.length) {
              <th [ngClass]="{ 'text-center': files.length }"> Opciones </th>
            }
          </tr>
        </thead>
        @if (files.length) {
          <tbody class="upload-name-style">
            @for (file of files; track file; let i = $index) {
              <tr>
                <td>
                  <div class="file-name">
                    {{ file.name }}
                  </div>
                </td>
                <td [ngClass]="{ 'text-center': files.length }">
                  @if (file.fileType === 'video') {
                    <div class="video-options">
                      <button
                        mat-icon-button
                        type="button"
                        [color]="color"
                        class="play-btn"
                        (click)="playVideo(file.previewSrc)"
                        matTooltip="Reproducir vídeo"
                      >
                        <mat-icon>play_circle</mat-icon>
                      </button>
                      <button mat-icon-button type="button" color="warn" class="play-btn" (click)="confirmRemoveFile(i)" matTooltip="Borrar archivo">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  } @else if (file.fileType === 'image') {
                    <div class="image-options">
                      <div class="file-preview" [style]="file.previewSrc"></div>
                      <button mat-icon-button type="button" color="warn" class="play-btn" (click)="confirmRemoveFile(i)" matTooltip="Borrar archivo">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  } @else if (file.fileType === 'document') {
                    <div class="document-options">
                      @if (file.previewSrc) {
                        <button
                          mat-icon-button
                          type="button"
                          [color]="color"
                          class="play-btn"
                          (click)="previewDocument(file.previewSrc)"
                          matTooltip="Previsualizar documento"
                        >
                          <mat-icon>file_open</mat-icon>
                        </button>
                      }
                      <button mat-icon-button type="button" color="warn" class="play-btn" (click)="confirmRemoveFile(i)" matTooltip="Borrar archivo">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        } @else {
          <tbody>
            <tr>
              <td>No has seleccionado archivos</td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  </div>
</div>
